import { Home, getStaticProps } from 'src/pages/[lang]/index'

export { getStaticProps }

export default Home
